module.exports = __webpack_public_path__ + "img/ovo.6d1da55d.png";